/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import { HFlow, Link, Theme, useTheme, VFlow } from 'bold-ui'
import { Box } from 'components/Box'
import { RouterLink } from 'components/route'
import { useServerTime } from 'hooks/useServerTime'

import { AcompanhamentoCard } from '../../components/AcompanhamentoCard'
import { IconLabelPreNatal } from './IconLabelPreNatal'
import { ImunobiologicoSection } from './ImunobiologicoSection'

interface VacinacaoGestacaoCardProps {
  dataInicioGestacao: Date
  vacinacaoPath: string
  loading: boolean
}

export function VacinacaoGestacaoCard(props: Readonly<VacinacaoGestacaoCardProps>) {
  const { dataInicioGestacao, vacinacaoPath, loading } = props
  const { getServerTimeNow } = useServerTime() // TODO - Remover ao passar os dados reais #25549
  const theme = useTheme()
  const styles = createStyles(theme)

  return (
    // TODO - Checar se há dados antes de renderizar o header e o body #25549
    <AcompanhamentoCard
      id='vacinacao'
      title='Vacinação'
      loading={loading}
      placeholder='Nenhuma vacinação registrada'
      headerContent={
        <Link
          component={RouterLink}
          to={vacinacaoPath}
          textDecoration='none'
          fontSize={0.875}
          style={styles.headerLink}
        >
          Visualizar calendário
        </Link>
      }
      justifyHeaderContent='space-between'
    >
      <VFlow vSpacing={0}>
        <Box style={styles.box}>
          <IconLabelPreNatal icon='needleFilled' iconText='Última aplicação' />
        </Box>
        <HFlow hSpacing={0.5} style={styles.bodyContent}>
          {/* TODO - Atualizar com linhas do resultado real da query #25549
          {!isEmpty(data) && data.map(() => ( */}
          <ImunobiologicoSection
            id={1}
            nomeImuno='Hepatite B (D1)'
            dataRegistro={getServerTimeNow()}
            dataInicioGestacao={dataInicioGestacao}
          />
        </HFlow>
        <Box style={styles.box}>
          <IconLabelPreNatal icon='calendarFilled' iconText='Aplicações aprazadas' />
        </Box>
        <HFlow hSpacing={0.5} style={styles.bodyContent}>
          {/* TODO - Atualizar com linhas do resultado real da query #25549
          {!isEmpty(data) && data.map(() => ( */}
          <ImunobiologicoSection
            id={2}
            nomeImuno='Hepatite B (D2)'
            dataRegistro={getServerTimeNow()}
            dataInicioGestacao={dataInicioGestacao}
            isAprazada
          />
        </HFlow>
      </VFlow>
    </AcompanhamentoCard>
  )
}

const createStyles = (theme: Theme) => ({
  headerLink: css`
    line-height: 1.8;
  `,
  bodyContent: css`
    padding: 0.5rem;
  `,
  box: css`
    margin: 0.5rem;
    padding: 0.5rem;
    border: 0;
    background: ${theme.pallete.gray.c90};
  `,
})
